import * as React from 'react';
import { observable, action, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { IOrganisation } from '../../model/ModelTypes';
import { isNullOrUndefined } from 'util';
import { IApi } from '../../utility/IApi';
import { IAuthenticationService } from '../../utility/IAuthenticationService';
import "./static/Login.scss";
import { CircularProgress, Button, TextField, SelectField, Snackbar } from 'react-md';
import { withRouter, BrowserHistory } from "react-router-dom";
import { IConfig } from '../../IConfig';
import { DataStore } from '../../repository/DataStore';
import { ServicesProvider } from '../../di/IServicesProvider';
import { flatMap } from 'rxjs/operators';
// var ableLogo = require("./static/able_logo.png");
const config: IConfig = require("Config");
const dataStore = new DataStore();
export class LoginModel {

    @observable parentOrganisations: IOrganisation[] = [];
    @observable childOrganisations: IOrganisation[] = [];
    @observable selectedParentOrganisation: IOrganisation;
    @observable selectedChildOrganisation: IOrganisation;
    @observable typedUsername: string = "";
    @observable typedPassword: string = "";
    @observable asyncOperationsCount = 0;
    @observable errorMessages: string[] = [];
    
    private api: IApi;
    private authenticationService: IAuthenticationService;
    private organisationsList: IOrganisation[];
    private readonly onLoginComplete: Function;
    constructor(api: IApi, authenticationService: IAuthenticationService, onLoginComplete: Function) {
        this.api = api;
        this.authenticationService = authenticationService;
        this.onLoginComplete = onLoginComplete;
    }
    @action fetchOrganisations() {
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
        this.api.getAllOrganisation().subscribe( 
            (result) => {
                this.organisationsList = result;
                runInAction( () => {
                    this.parentOrganisations = this.organisationsList.filter(
                        item => item.id !== "1" && item.id !== "2"  
                                && (item.parent_id === "null" || item.parent_id === "1" || item.parent_id === "2")
                    ).sort((a, b) => a.name.localeCompare(b.name));
                    this.asyncOperationsCount = this.asyncOperationsCount - 1;
                    if (!isNullOrUndefined(this.parentOrganisations) && this.parentOrganisations.length > 0) {
                        this.selectedParentOrganisation = this.parentOrganisations[0];
                    }
                });
            },
            (error) => {
                runInAction( () => {
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.errorMessages.push(error.response.data.error);
                    this.asyncOperationsCount = this.asyncOperationsCount - 1;
                });
            });
    }

    @action onParentOrganisationSelected(orgCode: string) {
        this.selectedChildOrganisation = undefined;
        let orgIndex = this.organisationsList.findIndex(item => item.code === orgCode);
        if (orgIndex > -1) {
            let parentOrganisation = this.organisationsList[orgIndex];
            this.selectedParentOrganisation = parentOrganisation;
            this.childOrganisations = this.organisationsList
            .filter(item => item.parent_id === parentOrganisation.id)
            .sort((a, b) => a.name.localeCompare(b.name));
            if (!isNullOrUndefined(this.childOrganisations) && this.childOrganisations.length > 0) {
                this.selectedChildOrganisation = this.childOrganisations[0];
            }
        }
    }

    @action onChildOrganisationSelected(orgCode: string) {
        let orgIndex = this.organisationsList.findIndex(item => item.code === orgCode);
        if (orgIndex > -1) {
            let childOrganisation = this.organisationsList[orgIndex];
            this.selectedChildOrganisation = childOrganisation;
        }
    }

    @action onSnackbarHidden(message: string) {
        let messageIndex = this.errorMessages.findIndex(item => item === message);
        if (messageIndex > -1) {
            this.errorMessages.splice(messageIndex, 1);
        }
    }   

    @action onLoginClicked(history: BrowserHistory) {
        let selectedOrganisation = isNullOrUndefined(this.selectedChildOrganisation) ? 
        this.selectedParentOrganisation : this.selectedChildOrganisation;
        if (isNullOrUndefined(selectedOrganisation)) {
            this.errorMessages.splice(0, this.errorMessages.length);
            this.errorMessages.push("Organisation is required");
            return;
        }
        this.asyncOperationsCount = this.asyncOperationsCount + 1;
        this.authenticationService.login(
            `${selectedOrganisation.code.toUpperCase()}-${this.typedUsername}`,
            this.typedPassword,
            selectedOrganisation.name,
            selectedOrganisation.code
        ).pipe(
            flatMap(user => {
                let x = ServicesProvider.GetServicesProviderWithUser(config, dataStore, user);
                return x;
            } )
        ).
        subscribe(
            provider => {
                if (!isNullOrUndefined(provider)) {
                    window.history.pushState("", "", '/');
                    if (!isNullOrUndefined(this.onLoginComplete)) {
                        this.onLoginComplete(provider);    
                    }
                } else {
                    throw Error("Invalid User");
                }
            },
            error => {
                runInAction( () => {
                    this.errorMessages.splice(0, this.errorMessages.length);
                    this.errorMessages.push(error.message);
                    this.asyncOperationsCount = 0;
                });
            }
        );

    }

    @action onTextFieldChange(key: string, value: string) {
        switch (key) {
            case "username":
                this.typedUsername = value;
                break;
            case "password":
                this.typedPassword = value;
                break;
            default:
                return;
        }
        
    }
}

@observer class LoginView extends React.Component<
{
    model: LoginModel, 
    history: BrowserHistory
}, {}> {

    componentDidMount() {
        setTimeout(() => {
            this.props.model.fetchOrganisations();    
        },         1000);
        
    }

    render() {
            return (
                
                <div className="container">
                    {
                        this.props.model.asyncOperationsCount > 0 &&
                        <CircularProgress centered={true} id="Progress" />
                    }
                    {this.props.model.asyncOperationsCount === 0 && this.props.model.parentOrganisations.length !== 0 &&
                    <form className="formContainer">
                    <h1 className="header" >Log in</h1>
                    
                    {
                        this.props.model.parentOrganisations.length > 0 &&
                      
                        <SelectField
                            id="parentOrganisation"
                            label="Organisation"
                            placeholder="Select Organisation"
                            menuItems={
                                this.props.model.parentOrganisations.map(item => {
                                        return {label: item.name, value: item.code};
                                })
                            }
                            defaultValue={this.props.model.parentOrganisations[0].code}
                            value={isNullOrUndefined(this.props.model.selectedParentOrganisation) ? 
                                this.props.model.parentOrganisations[0].code
                                : this.props.model.selectedParentOrganisation.code
                            }
                            onChange={(value) => this.props.model.onParentOrganisationSelected(value.toString())}
                        /> 
                 
                    } 
                    {
                        this.props.model.childOrganisations.length > 0 &&
                        <SelectField
                            id="childOrganisation"
                            label="Sub Organisation"
                            defaultVisible={true}
                            placeholder="Select Organisation"
                            menuItems={
                                this.props.model.childOrganisations.map(item => {
                                        return {label: item.name, value: item.code};
                                })
                            }
                            defaultValue={this.props.model.childOrganisations[0].code}
                            value={isNullOrUndefined(this.props.model.selectedChildOrganisation) ? 
                                this.props.model.childOrganisations[0].code
                                : this.props.model.selectedChildOrganisation.code
                            }
                            onChange={(value) => this.props.model.onChildOrganisationSelected(value.toString())}
                        />
                    } 
                    <div className="inputContianer">
              
                            <TextField
                                id="userInput"
                                className="stackableTextInputRight"
                                fullWidth={false}
                                label="Username" 
                                type="text" 
                                onChange={(e) => this.props.model.onTextFieldChange("username", e.toString())}
                                value={this.props.model.typedUsername}
                            />
                      
                            <TextField
                                id="passwordInput"
                                className="stackableTextInputLeft"
                                fullWidth={false}
                                label="Password" 
                                type="password" 
                                onChange={(e) => this.props.model.onTextFieldChange("password", e.toString())}
                                value={this.props.model.typedPassword}
                            />
                      
                    </div>
                    <a 
                        onClick={() => this.props.history.push("/passwords/forget")}
                        href="" 
                        className="resetPasswordLink"
                    > 
                        Forgot Password? 
                    </a>
                    <div>
                    <Button
                        className="loginButton margin-top-10" 
                        
                        secondary={true}
                        raised={true} 
                        onClick={(e) => {
                            this.props.model.onLoginClicked(this.props.history); 
                            e.preventDefault(); }}
                    >
                    Login
                    </Button>
                    </div>
                    
                    </form>
                    }
                    {
                    this.props.model.asyncOperationsCount === 0 && 
                    this.props.model.parentOrganisations.length !== 0 &&
                    <div className='secondary-option'>
                        <h2>Don't have an account?</h2>
                        <div>
                            <Button
                                raised={true}
                                secondary={true}
                                swapTheming={true}
                                className='loginButton'
                                onClick={() => this.props.history.push("/register")}
                            >
                            Register
                            </Button>
                        </div>
                    </div>
                }
                <Snackbar
                    id="errors-snackbar"
                    toasts={this.props.model.errorMessages.map(item => {
                        return {
                            text: item
                        };
                    })}
                    autohide={true}
                    onDismiss={() => {
                        this.props.model.errorMessages = [];
                    }}
                />
                </div>
            );
 
    }
}

export default withRouter(LoginView);


// WEBPACK FOOTER //
// ./src/view/Login/Login.tsx